<template>
  <div></div>
</template>

<script>
export default {
  name: "HistoryJobs",
  data() {
    return {
      activeIndex: "/HistoryJobs/HistoryJobs",
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver Jobs",
          command: "view"
        }
      ],
      columns: [
        {
          prop: "Name",
          label: "Nombre Jobs",
          sortable: true
        },
        {
          prop: "Inicio",
          label: "Fecha de Inicio",
          sortable: true
        },
        {
          prop: "Finalizacion",
          label: "Fecha de Finalizacion",
          sortable: true
        },
        {
          prop: "Duracion",
          label: "Duracion",
          sortable: true
        }
      ]
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleSelect(key, keyPath) {
      if (key.charAt(0) === "/") {
        this.$router.push(key);
        this.$emit("push-page", { page: key });
      }
    },
    setLink(path) {
      this.activeIndex = path;
    }
  },
  created() {
    if (this.$router.currentRoute.path === "/HistoryJobs") {
      this.handleSelect(this.activeIndex);
    }
    this.setLink(this.$router.currentRoute.path);
    // eslint-disable-next-line
        this.$router.afterEach((to, from) => {
      this.setLink(this.$router.currentRoute.path);
    });
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
